module.exports = __webpack_public_path__ + "static/28-b3ad7563c9a61ee018aebabaee036a31.png";